"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=avatar.js.map